import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { ShowFullClubProfileRequest } from '@/features/work/api/show-full-club-profile';
import { showFullClubProfile } from '@/features/work/api/show-full-club-profile';

export const useShowFullClubProfileQuery = (
  params: ShowFullClubProfileRequest,
  settings?: QuerySettings<typeof showFullClubProfile>
) =>
  useQuery({
    queryKey: ['showFullClubProfile', params.profileId],
    queryFn: () =>
      showFullClubProfile({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
